module.exports = __webpack_public_path__ + "static/media/ondc.28e3e01a.svg";